// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { AuditEventListItem } from '@/audit/components/audit-event-list-item';
import { getTimeRecordAuditEvents } from '@/costs/api/get-time-record-audit-events';
import { Stack } from '@mui/material';
import { useSuspenseQuery } from '@tanstack/react-query';

interface Props {
  timeRecordKey: string;
}

/**
 * Displays a vertical list of audit events for a specific time record.
 * This component suspends while fetching the audit events.
 */
export function TimeRecordAuditList(props: Props) {
  const { data } = useSuspenseQuery({
    queryKey: ['time-record', props.timeRecordKey, 'audit'],
    queryFn: () => getTimeRecordAuditEvents(props.timeRecordKey),
    retry: false,
  });

  return (
    <Stack spacing={2}>
      {data.events.map((event) => (
        <AuditEventListItem key={event.id} event={event} />
      ))}
    </Stack>
  );
}
